import React from "react";
import { Button } from "@mui/material";


const TempParticpantCard = ({uniqueID, name, dob, waiver, event}) => {

    const formatDate = (isoString) => {
        if (isoString === "Date of Birth") return isoString; 
        if (!isoString) return "N/A";
        
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return "Invalid Date";

        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();

        return `${day}/${month}/${year}`;
    };

    const isHeader = uniqueID === "Unique ID";

    const handleViewWaiver = () => {
        window.open(`/api/download-waiver/${uniqueID}/${event}`, '_blank');
    };

    return (
        <div style={{
            display: "flex", 
            width: "100%", 
            borderTop: "1px black dashed", 
            borderBottom: "1px black dashed", 
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px"
        }}>
            <div style={{ flex: 1 }}>{uniqueID}</div>
            <div style={{ flex: 2 }}>{name}</div>
            <div style={{ flex: 1 }}>{formatDate(dob)}</div>
            <div style={{ flex: 1, textAlign: "right" }}>
                {isHeader ? (
                    "Signed Waiver"
                ) : (
                    <button 
                        onClick={handleViewWaiver}
                        style={{
                            backgroundColor: "#B12F6B",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            padding: "4px 8px",
                            cursor: "pointer"
                        }}
                    >
                        View PDF
                    </button>
                )}
            </div>
        </div>
    );
}



export default TempParticpantCard;